import React from 'react'
import { InlineDisplayContent, TextInput } from '@ztechapps/webui.input'
import { Stack } from 'react-bootstrap'
import { useCheckoutContext } from '../../index'

export const CustomerInfo = () => {
  const context = useCheckoutContext()
  const [shippingOptions, setShippingOptions] = context.shippingOptions

  return (
    <Stack gap={2}>
      <div>
        <InlineDisplayContent
          label="Your Name"
          help='The carrier use this information as the "attention line" of address, and when signature is needed during delivery.'
        >
          <TextInput
            placeholder="Set your name."
            value={shippingOptions?.name}
            onChange={(e) => {
              setShippingOptions({ name: e?.target.value })
            }}
          />
        </InlineDisplayContent>
      </div>

      <div>
        <InlineDisplayContent label="Email address">
          <TextInput
            placeholder="Set your email address."
            value={shippingOptions?.email}
            onChange={(e) => {
              setShippingOptions({ email: e?.target.value })
            }}
          />
        </InlineDisplayContent>
      </div>
    </Stack>
  )
}
